import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import { CostChanged, UpdateCostSuccess } from '../actions/cost.actions';
import { CloseCEUpdateCostDialog, OpenCEUpdateCostDialog } from '../actions/search.actions';
import { CostState } from '../models/campaign-management.model';

export const initialState: CostState = {
  cost: 0,
  column: '',
};

export const CostReducer = createReducer(
  initialState,
  on(OpenCEUpdateCostDialog, (state, { row, columnVal }) => ({
    ...state,
    cost: row[columnVal as keyof typeof row] ? Number(row[columnVal as keyof typeof row]) : 0,
    column: columnVal,
  })),
  on(CostChanged, (state, { cost }) => ({
    ...state,
    cost,
  })),
  on(ActiveComponentChanged, CloseCEUpdateCostDialog, UpdateCostSuccess, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
